import { ArrowRightFromBracketRegularIcon } from "@elixir/icons";
import { Appointment, APPOINTMENT_STATUS } from "@elixir/types";
import { ChipWithTooltip } from "ui";
import usePostEndVisit from "../../../../apis/tryst/post-end-visit";

const CheckOutButton = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const { mutateAsync: postEndVisit } = usePostEndVisit();
  return (
    <ChipWithTooltip
      title="Exit"
      tooltipText="Check-out"
      icon={<ArrowRightFromBracketRegularIcon className="dr-w-13 dr-h-13" />}
      className={className}
      iconOnly={true}
      variant="danger"
      onClick={async () => {
        const { aid, clinic_id, doctor_oid, patient_oid, start_time } = apt;
        await postEndVisit({
          status: APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
          aid: aid,
          doctor: {
            oid: doctor_oid,
            clinic: clinic_id,
          },
          pid: { oid: patient_oid },
          visit: { st: start_time, et: new Date().toISOString() },
        });
      }}
      type={type}
    />
  );
};

export default CheckOutButton;
